import { FC } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { KTSVG } from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import asideToggleSvg from '../../../../assets/media/icons/duotune/arrows/arr079.svg'
import logoNegativa from '../../../../assets/media/logos/Logo Negativa.png'
// import logoMain from '../../../../assets/media/logos/logo-principal.png'
// import logoMain4 from '../../../../assets/media/logos/logo-monocromatica-verde.png'
// import logoMain3 from '../../../../assets/media/logos/Logo Fundo Verde.png'
// import logoMain3 from '../../../../assets/media/logos/logo-principal.png'

const AsideDefault: FC = () => {
  const { config, classes } = useLayout()
  const { aside } = config

  return (
    <div
      id="kt_aside"
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer="true"
      data-kt-drawer-name="aside"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction="start"
      data-kt-drawer-toggle="#kt_aside_mobile_toggle"
    >
      <div className="aside-logo flex-column-auto" id="kt_aside_logo">
        {aside.theme === 'dark' && (
          <a href="/dashboard">
            <span className="h-55px w-150px logo">
              <img
                alt="Logo"
                className="h-55px logo object-fit-cover"
                src={logoNegativa}
                style={{ objectFit: 'cover' }}
              />
            </span>
          </a>
        )}
        {aside.theme === 'light' && (
          <a href="/dashboard">
            <img
              alt="Logo"
              className="h-55px w-150px logo object-fit-cover"
              src={logoNegativa}
              style={{ objectFit: 'cover' }}
            />
          </a>
        )}

        {aside.minimize && (
          <div
            id="kt_aside_toggle"
            className="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
            data-kt-toggle="true"
            data-kt-toggle-state="active"
            data-kt-toggle-target="body"
            data-kt-toggle-name="aside-minimize"
          >
            <KTSVG path={asideToggleSvg} className={'svg-icon-1 rotate-180'} />
          </div>
        )}
      </div>

      <div className="aside-menu flex-column-fluid">
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
    </div>
  )
}

export { AsideDefault }
